export const Upload = "Upload/";

export const RemoveKey = Upload + "RemoveKey";
export const FileUpload = Upload + "FileUpload";
export const IndRunning = Upload + "IndRunning";
export const FileExport = Upload + "FileExport";
export const Import = "Import";
export const CentralImport = Import + "/CentralImport";
export const EmploymentEquityGroupImport = Import + "/EmploymentEquityGroupImport";
export const ImportHelpfile =  Upload + 'ImportHelpfile';
export const ImportTemplate =  Upload + 'ImportTemplate';
export const WSPImportJobTitle = Upload + 'Import';
export const MultiDataPageImport = Import + '/MultiDataPageImport';
export const GenerateSalaryExcelImportTemplate = Import + '/GenerateSalaryExcelImportTemplate';
export const PayrollImport = Import + "/PayrollImport";
